export default __webpack_public_path__ + "static/media/logo2.6e86f4b5.png";